import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightXsmall = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#757575",
		d: "M12.6484 10.1016L8.89844 6.375C8.6875 6.14062 8.33594 6.14062 8.10156 6.375C7.89062 6.58594 7.89062 6.9375 8.10156 7.14844L11.4766 10.5L8.125 13.875C7.89062 14.0859 7.89062 14.4375 8.125 14.6484C8.33594 14.8828 8.6875 14.8828 8.89844 14.6484L12.6484 10.8984C12.8828 10.6875 12.8828 10.3359 12.6484 10.1016Z"
	})
});
const ForwardRef = forwardRef(SvgArrowRightXsmall);
export default ForwardRef;
